import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FormControlLabel, Checkbox } from '@mui/material';
import styles from './ChooseFileWithCount.module.scss';

export default function ChooseFileWithCount({ actionHandler, fileCounter, disabled = false, isChecked, isEdit }) {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [toggle, setToggle] = useState(false);

  const handleChecked = (e) => {
    setToggle(false);
    setChecked(e.target.checked);
    actionHandler(e.target.checked);
  };

  const handleToggle = () => {
    if (fileCounter > 0) {
      actionHandler(checked || isChecked);
    } else {
      setToggle(!toggle);
    }
  };

  return (
    <div className={styles.mainWrapper}>
      {isEdit ? (
        <div className={styles.chooseFileWrapper}>
          {isChecked || checked ? (
            <span className={styles.textStyle}>{t('dashboard.expenses.table.noreceipt')}</span>
          ) : (
            <>
              <button
                disabled={disabled}
                className={styles.chooseFileButton}
                onClick={() => actionHandler(checked || isChecked)}
              >
                <span>{t('common.general.choosefile')}</span>
              </button>
              <span className={styles.chooseFileCounter}>{fileCounter}</span>
            </>
          )}

          <KeyboardArrowDownIcon onClick={handleToggle} sx={{ color: '#D1D3D4', cursor: 'pointer' }} />
        </div>
      ) : (
        <div>
          {isChecked || checked ? (
            <span className={styles.textStyle}>{t('dashboard.expenses.table.noreceipt')}</span>
          ) : (
            <>
              <span className={styles.textStyle}>
                {fileCounter > 0
                  ? `${t('dashboard.expenses.table.attachment')} ${fileCounter}`
                  : t('dashboard.expenses.table.noreceipt')}
              </span>
              {!!fileCounter && (
                <ArrowForwardIosIcon
                  onClick={() => actionHandler(checked || isChecked)}
                  sx={{ marginLeft: '10px', opacity: 0.3, fontSize: '14px', cursor: 'pointer' }}
                />
              )}
            </>
          )}
        </div>
      )}
      {toggle && fileCounter === 0 && isEdit && (
        <div className={styles.chooseExtendWrapper}>
          <FormControlLabel
            control={<Checkbox checked={checked || isChecked} onChange={handleChecked} />}
            label={t('dashboard.createclaim.steps.noreceipt')}
            sx={{
              margin: 0,
              '& .MuiTypography-root': {
                fontSize: '10px'
              }
            }}
          />
        </div>
      )}
    </div>
  );
}
